PT.Utils.featureActive = (feature) ->
  if PT.Flags? then _.includes(PT.Flags, feature) else false
